import _ from 'lodash';

import {transformFiltersForStoreToFiltersForApi} from 'utils/filters';
import {transformPaginationForStoreToPaginationForApi} from 'utils/pagination';
import {transformSortForStoreToSortForUrl} from 'utils/sort'; // todo dedup import
import {selectSort, SORTING} from 'ducks/sorting';
import {selectPagination, PAGINATION} from 'ducks/pagination';
import {selectFilters, FILTERS} from 'ducks/filters';

import {
  createReducer,
  createFetchSelectors,
  createFetchReducersWithPagination,
  createFetchPaginatedActionForNamespace
} from 'utils/reducers';
import {attachUuidKey} from 'utils/common';

export const INITIATE_GO_CARDLESS_PAYMENTS_FLOW =
  'reporting/invoices/INITIATE_GO_CARDLESS_PAYMENTS_FLOW';
export const UPDATE_SELECTED_INVOICES_FOR_PAYMENT_INITIATION =
  'reporting/invoices/UPDATE_SELECTED_INVOICES_FOR_PAYMENT_INITIATION';
export const PREVIEW_INVOICES_FOR_PAYMENT_INITIATION =
  'reporting/invoices/PREVIEW_INVOICES_FOR_PAYMENT_INITIATION';
export const PREVIEW_INVOICES_FOR_PAYMENT_INITIATION_SUCCESS =
  'reporting/invoices/PREVIEW_INVOICES_FOR_PAYMENT_INITIATION_SUCCESS';
export const PREVIEW_INVOICES_FOR_PAYMENT_INITIATION_FAILURE =
  'reporting/invoices/PREVIEW_INVOICES_FOR_PAYMENT_INITIATION_FAILURE';
export const BULK_INITIATE_GO_CARDLESS_PAYMENTS =
  'reporting/invoices/BULK_INITIATE_GO_CARDLESS_PAYMENTS';
export const BULK_INITIATE_GO_CARDLESS_PAYMENTS_SUCCESS =
  'reporting/invoices/BULK_INITIATE_GO_CARDLESS_PAYMENTS_SUCCESS';
export const BULK_INITIATE_GO_CARDLESS_PAYMENTS_FAILURE =
  'reporting/invoices/BULK_INITIATE_GO_CARDLESS_PAYMENTS_FAILURE';

const createFetchActionWithPagination = createFetchPaginatedActionForNamespace(
  'reporting/invoices'
);

export const fetchInvoicesForReporting = createFetchActionWithPagination({
  name: 'FETCH_INVOICES_FOR_REPORTING',
  initialAction: ({locationRef}, extraActions = []) => ({
    payload: {locationRef, extraActions}
  }),
  stateKey: 'invoices',
  defaultStateValue: [],
  extraGetParamsSelectors: [
    state =>
      transformFiltersForStoreToFiltersForApi(
        selectFilters(state, FILTERS.INVOICE_REPORTING_LIST)
      ),
    state =>
      transformPaginationForStoreToPaginationForApi(
        selectPagination(state, PAGINATION.INVOICE_REPORTING_LIST)
      ),
    state =>
      transformSortForStoreToSortForUrl(
        selectSort(state, SORTING.INVOICE_REPORTING_LIST)
      )
  ],
  paginationNamespace: PAGINATION.INVOICE_REPORTING_LIST
});

const fetchInvoicesForReportingSelector = createFetchSelectors(
  fetchInvoicesForReporting
);

export const selectInvoicesForReporting =
  fetchInvoicesForReportingSelector.data;

export const selectAreInvoicesForReportingLoading =
  fetchInvoicesForReportingSelector.isLoading;

export const initiateGoCardlessPaymentsFlow = ({invoicesIds = []}) => ({
  type: INITIATE_GO_CARDLESS_PAYMENTS_FLOW,
  payload: {
    invoicesIds
  }
});

export const updateSelectedInvoicesForPaymentInitiation = ({
  invoicesIds = []
}) => ({
  type: UPDATE_SELECTED_INVOICES_FOR_PAYMENT_INITIATION,
  payload: {
    invoicesIds
  }
});

export const getSelectedInvoicesForPaymentInitiation = state =>
  _.get(state, 'reporting.invoices.selectedInvoicesForPaymentInitiation', []);

export const MODALS = {
  EXCLUDED_INVOICES_FROM_PAYMENT_INITIATION:
    'excludedInvoicesFromPaymentInitiation',
  PREVIEW_INVOICES_FOR_PAYMENT_INITIATION: 'previewInvoicesForPaymentInitiation'
};

export const previewInvoicesForPaymentInitiation = (
  {invoicesIds = []},
  extraActions
) => ({
  type: PREVIEW_INVOICES_FOR_PAYMENT_INITIATION,
  payload: {
    invoicesIds,
    extraActions
  }
});

export const previewInvoicesForPaymentInitiationSuccess = data => ({
  type: PREVIEW_INVOICES_FOR_PAYMENT_INITIATION_SUCCESS,
  payload: {
    data
  }
});

export const previewInvoicesForPaymentInitiationFailure = errors => ({
  type: PREVIEW_INVOICES_FOR_PAYMENT_INITIATION_FAILURE,
  payload: {
    errors
  }
});

export const bulkInitiateGoCardlessPayments = (
  {invoicesIds, specifiedDesiredPaymentDate, takePaymentAtEarliestChargeDate},
  extraActions
) => ({
  type: BULK_INITIATE_GO_CARDLESS_PAYMENTS,
  payload: {
    invoicesIds,
    specifiedDesiredPaymentDate,
    takePaymentAtEarliestChargeDate,
    extraActions
  }
});

export const bulkInitiateGoCardlessPaymentsSuccess = data => ({
  type: BULK_INITIATE_GO_CARDLESS_PAYMENTS_SUCCESS,
  payload: {
    data
  }
});

export const bulkInitiateGoCardlessPaymentsFailure = errors => ({
  type: BULK_INITIATE_GO_CARDLESS_PAYMENTS_FAILURE,
  payload: {
    errors
  }
});

const initialState = {};

const fetchInvoiceReducers = createFetchReducersWithPagination(
  fetchInvoicesForReporting,
  (state, action) => ({
    ...state,
    [action.parent.stateKey]: {
      data: action.payload.results.map(attachUuidKey),
      isLoading: false
    }
  })
);

const fetchReducers = createReducer(initialState, {
  ...fetchInvoiceReducers
});

const reducer = (state = initialState, action) => {
  const newState = fetchReducers(state, action);

  switch (action.type) {
    case UPDATE_SELECTED_INVOICES_FOR_PAYMENT_INITIATION:
      return {
        ...state,
        selectedInvoicesForPaymentInitiation: action.payload.invoicesIds
      };

    default:
      return newState;
  }
};

export default reducer;

export {default as invoiceReportingSaga} from './saga';
